<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} {{aLang.af_title}}</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} {{aLang.af_title}}</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} {{aLang.af_title}}</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-form-item :label="aLang.af_name + aLang.af_vietnam" prop="ten.vi">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten.vi"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item :label="aLang.af_name + aLang.af_english" prop="ten.en">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten.en"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  {{aLang.af_address}}
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseDiaChi
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseDiaChi" visible>
                  <b-row>
                    <b-col md="4">
                      <el-form-item :label="aLang.af_province" prop="dia_chi.province_name">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.dia_chi.province_name"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item :label="aLang.af_commune" prop="dia_chi.commune_name">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.dia_chi.commune_name"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <el-form-item :label="aLang.af_address" prop="dia_chi.dia_chi">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.dia_chi.dia_chi"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  {{aLang.af_phone}}
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseDienThoai
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseDienThoai" visible>
                  <b-row>
                    <b-col md="4">
                      <el-form-item :label="aLang.af_area_code" prop="dien_thoai.ma_vung">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.dien_thoai.ma_vung"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>

                    <b-col md="4">
                      <el-form-item :label="aLang.af_landline_phone" prop="dien_thoai.tel">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.dien_thoai.tel"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item :label="aLang.af_fax" prop="dien_thoai.fax">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.dien_thoai.fax"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <el-form-item :label="aLang.af_logo" prop="logo">
                <el-input
                  type="text"
                  v-model="mData.dataForm.logo"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item :label="aLang.af_email" prop="email">
                <el-input
                  type="text"
                  v-model="mData.dataForm.email"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item :label="aLang.af_website" prop="website">
                <el-input
                  type="text"
                  v-model="mData.dataForm.website"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <el-form-item :label="aLang.af_type" prop="loai_hinh_id">
                <el-select
                  v-model="mData.dataForm.loai_hinh_id"
                  :placeholder="aLang.c_select"
                  clearable
                  filterable
                  :disabled="mData.viewMode != 'create'"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listLoaiHinh"
                    :key="item.id"
                    :label="item.ten.vi"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item :label="aLang.af_ratings" prop="xep_hang_id">
                <el-select
                  v-model="mData.dataForm.xep_hang_id"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listXepHang"
                    :key="item.id"
                    :label="item.ten.vi"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>

            <b-col md="4">
              <el-form-item :label="aLang.af_service" prop="dich_vu_ids">
                <el-select
                  v-model="mData.dataForm.dich_vu_ids"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  multiple
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listDichVu"
                    :key="item.id"
                    :label="item.ten.vi"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <el-form-item :label="aLang.af_decision_number" prop="so_quyet_dinh">
                <el-input
                  type="text"
                  v-model="mData.dataForm.so_quyet_dinh"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>

            <b-col md="6">
              <el-form-item :label="aLang.af_decision_date" prop="ngay_quyet_dinh">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ngay_quyet_dinh"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <el-form-item :label="aLang.af_total_number_of_rooms" prop="tong_so_phong">
                <el-input
                  type="text"
                  v-model="mData.dataForm.tong_so_phong"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>

            <b-col md="4">
              <el-form-item :label="aLang.af_lowest_price" prop="gia.thap_nhat">
                <el-input
                  type="text"
                  v-model="mData.dataForm.gia.thap_nhat"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>

            <b-col md="4">
              <el-form-item :label="aLang.af_highest_price" prop="gia.cao_nhat">
                <el-input
                  type="text"
                  v-model="mData.dataForm.gia.cao_nhat"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import ProvinceApi from "../../../moduleApi/ProvinceApi";
import DistrictApi from "../../../moduleApi/DistrictApi";
import CoSoLuuTruModel from "./CoSoLuuTruModel";
import CoSoLuuTruApi from "../../../moduleApi/CoSoLuuTruApi";
import MapComponent from "../../../component/MapComponent";
import EditorComponent from "../../../component/EditorComponent";
import LoaiHinhCSLTApi from "../../../moduleApi/LoaiHinhCSLTApi";
import XepHangCSLTApi from "../../../moduleApi/XepHangCSLTApi";
import DichVuCSLTApi from "../../../moduleApi/DichVuCSLTApi";

export default {
  components: {
    MapComponent,
    EditorComponent
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "CoSoLuuTru",
        dataDefault: {
          roles: DataService.rolesInForm,
          listProvince: [],
          listDistrict: [],
          listKhachDuLich: [],
          listHuongDanVien: [],
          listCongTyLuHanh: [],
          listTour: [],
          listDichVu: [],
          listLoaiHinh: [],
          listXepHang: [],
          listDanhMucCoSoLuuTru: [],
          listDoiTuongHienThi: DataService.doiTuongHienThi,
          listLanguage: DataService.Languages,
          searchMap: ""
        },
        dataForm: MethodService.copyObject(CoSoLuuTruModel.dataForm),
        validForm: CoSoLuuTruModel.validForm
        // dialog: {},
        // fileUploadOption: MethodService.copyObject(
        //   CoSoLuuTruModel.dataFormOther.fileUploadOption
        // ),
        // dataPropMap: {
        //   fn_addLatLng: this.fn_addLatLng,
        //   lat: "",
        //   lng: "",
        //   showMap: false,
        //   id: "MapDiaDiem",
        //   reload: 0
        // }
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          // if (data.noi_dung) {
          //   //replace http để lấy id ảnh
          //   data.noi_dung = MethodService.replaceURLImage(data.noi_dung);
          // }
          // if (!this.mData.dataPropMap.showMap) {
          //   data.dia_diem.lat = null;
          //   data.dia_diem.lng = null;
          // }
          if (type == "create") {
            await CoSoLuuTruApi.create(data);
            this.fn_resetForm();
          }
          if (type == "update") {
            data.id = this.$router.currentRoute.params.id;
            await CoSoLuuTruApi.update(data);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(CoSoLuuTruModel.dataForm);
      // this.mData.dataForm.noi_dung = "";
      // this.mData.fileUploadOption = MethodService.copyObject(
      //   CoSoLuuTruModel.dataFormOther.fileUploadOption
      // );
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await CoSoLuuTruApi.findById(id);

      // if (res.result.anh && res.result.anh.anh_dai_dien) {
      //   let data = {
      //     id: res.result.anh.anh_dai_dien,
      //     name: res.result.anh.anh_dai_dien,
      //     url: ExtensionService.urlImg + res.result.anh.anh_dai_dien
      //   };
      //   this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
      // }
      // if (res.result.anh && res.result.anh.anh_tin_tuc) {
      //   var data = [];
      //   for (let i = 0; i < res.result.anh.anh_tin_tuc.length; i++) {
      //     let item = {
      //       id: res.result.anh.anh_tin_tuc[i],
      //       name: res.result.anh.anh_tin_tuc[i],
      //       url: ExtensionService.urlImg + res.result.anh.anh_tin_tuc[i]
      //     };
      //     data.push(item);
      //   }

      //   this.mData.fileUploadOption.AnhCoSoLuuTru.fileList = data;
      // }
      // if (res.result.noi_dung) {
      //   res.result.noi_dung = MethodService.unreplaceURLImage(
      //     res.result.noi_dung
      //   );
      // }
      // if (
      //   res.result.dia_diem &&
      //   res.result.dia_diem.lat &&
      //   res.result.dia_diem.lng
      // ) {
      //   this.mData.dataPropMap.lat = res.result.dia_diem.lat;
      //   this.mData.dataPropMap.lng = res.result.dia_diem.lng;
      //   this.mData.dataPropMap.showMap = true;
      // }
      this.mData.dataForm = res.result;
    },
    async fn_initDataDefault() {
      let reqProvinceApi = ProvinceApi.list({ limit: 1000 });
      let reqLoaiHinh = LoaiHinhCSLTApi.list({ limit: 1000 });
      let reqXepHang = XepHangCSLTApi.list({ limit: 1000 });
      let reqDichVu = DichVuCSLTApi.list({ limit: 1000 });

      let resProvinceApi = await reqProvinceApi;
      let resLoaiHinh = await reqLoaiHinh;
      let resXepHang = await reqXepHang;
      let resDichVu = await reqDichVu;

      this.mData.dataDefault.listProvince = resProvinceApi.result;
      this.mData.dataDefault.listLoaiHinh = resLoaiHinh.result;
      this.mData.dataDefault.listXepHang = resXepHang.result;
      this.mData.dataDefault.listDichVu = resDichVu.result;
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    }
  },
  created: function() {
    this.fn_initDataDefault();

    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>
<style scoped>
</style>